import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "react-query";

import { updateUnitSystem } from "../server/serverOperation.js";
import useParamSelector from '../data/useParamSelector.js'
import { 
  selectCurrentComponentDesc, 
} from '../data/devicesSlice.js';
import { 
  selectUserPhoneId,
  selectUnitSystem,
  unitSystemSet,
} from "../data/uiSlice.js";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import { withTranslation } from 'react-i18next';

function PureUnitSystemButtons({ t, block }) {
  const dispatch = useDispatch();
  const disabled = block.disabled ?? false;
  const componentId = block.id;
  const userPhoneId = useSelector(selectUserPhoneId);
  const data = useParamSelector(selectCurrentComponentDesc, componentId);
  const desc = data.description;
  const labels = desc?.LABELS.map( l => l[0]);
  const values = desc?.LABELS.map( l => l[1]);
  const title = desc?.TITLE;
  const currentUnitSystem = useSelector(selectUnitSystem);
  const buttonValue = values.indexOf(currentUnitSystem);

  const handleChange = (event, newIndex) => {
    const unitSystem = values[newIndex];
    dispatch(unitSystemSet(unitSystem));
    mutate({userPhoneId, unitSystem});
  };

  const { mutate, isLoading, error } = useMutation(
    updateUnitSystem, // userPhoneId, unitSystem}
    {
      // onSuccess: async (data) => {
      //   console.log(data);
      // },
      onError: (error) => {
        console.log(error);
      }
    }
  );

  return (
    <FormControl style={{textAlign: "left", marginLeft: "1em"}}>
      <FormLabel>{t(title)}</FormLabel>
      <RadioGroup
        row
        name="row-radio-buttons-group"
        value={buttonValue}
        onChange={handleChange}
      >
        {labels.map ( (label, i) =>
          <FormControlLabel key={label} value={i} control={<Radio disabled={disabled}/>} label={t(label)} />
        )}
      </RadioGroup>
    </FormControl>
  );
};


const UnitSystemButtons = withTranslation()(PureUnitSystemButtons);

export {
  UnitSystemButtons
};